import LogoColor from '../../../../assets/images/logo-color.svg';
import IconClose from '../../../../assets/icons/ic-close.svg';
import { Link as LinkScroll } from 'react-scroll';
import IconFacebook from '../../../../assets/icons/ic-facebook.svg';
import IconInstagram from '../../../../assets/icons/ic-instagram.svg';
import ImageHeaderMobile from '../../../../assets/images/img-header-mobile.png';
import styles from './navigation-mobile.module.scss';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface INavigationMobileProps {
  isOpen: boolean;
  handleCloseSidebar: () => void;
}

const NavigationMobile = (props: INavigationMobileProps) => {
  const { t } = useTranslation('header');

  return (
    <div
      className={`absolute top-0 left-0 z-50 w-full ${styles.headerMobile} ${
        props.isOpen ? styles.active : ''
      }`}
    >
      <div className="relative bg-header-mobile pt-4 pb-[41px] px-4">
        <div className="absolute bottom-0 left-0 right-0">
          <img src={ImageHeaderMobile} alt="header mobile" className="w-full" />
        </div>

        <div className="absolute top-10 right-4" onClick={() => props.handleCloseSidebar()}>
          <img src={IconClose} alt="close" />
        </div>

        <div className="w-full">
          <img src={LogoColor} alt="logo color" className="w-[72px] h-[72px] m-auto" />
        </div>

        <ul className="flex flex-col items-center gap-y-6 mt-12 text-[14px] font-semibold text-blue-300">
          <li className="cursor-pointer z-50">
            <LinkScroll
              activeClass="border-b border-white pb-1"
              to="aboutUs"
              hashSpy={true}
              spy={true}
              smooth={true}
            >
              {t('navigation.introduction')}
            </LinkScroll>
          </li>
          <li className="cursor-pointer z-50">
            <LinkScroll
              activeClass="border-b border-white pb-1"
              to="menu"
              hashSpy={true}
              spy={true}
              smooth={true}
            >
              {t('navigation.menu')}
            </LinkScroll>
          </li>
          <li className="cursor-pointer z-50">
            <LinkScroll
              activeClass="border-b border-white pb-1"
              to="feedback"
              hashSpy={true}
              spy={true}
              smooth={true}
            >
              {t('navigation.feedback')}
            </LinkScroll>
          </li>
          <li className="cursor-pointer z-50">
            <LinkScroll
              activeClass="border-b border-white pb-1"
              to="service"
              hashSpy={true}
              spy={true}
              smooth={true}
            >
              {t('navigation.service')}
            </LinkScroll>
          </li>
          <li className="cursor-pointer z-50">
            <LinkScroll
              activeClass="border-b border-white pb-1"
              to="news"
              hashSpy={true}
              spy={true}
              smooth={true}
            >
              {t('navigation.news')}
            </LinkScroll>
          </li>
          <li className="cursor-pointer z-50">
            <LinkScroll
              activeClass="border-b border-white pb-1"
              to="contactUs"
              hashSpy={true}
              spy={true}
              smooth={true}
            >
              {t('navigation.contact')}
            </LinkScroll>
          </li>
        </ul>

        <div className="flex items-center justify-center gap-x-4 mt-10">
          <Link to={'https://google.com.vn'} className="z-50">
            <img src={IconFacebook} alt="facebook" />
          </Link>
          <Link to={'https://google.com.vn'} className="z-50">
            <img src={IconInstagram} alt="instagram" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NavigationMobile;
